<template>
<b-container fluid>
  <br>
  <h1>Enter Voucher Code</h1>
  <b-row class="justify-content-md-center">
    <b-col lg="4" sm="8" offset-sm="2" offset="0" offset-md="0">
      <b-form v-on:submit.prevent="submitVoucher">

    <b-form-input id="voucher-id" v-model="voucher" class="mt-2"></b-form-input>
          <b-form-invalid-feedback :state="valid"
      id="voucher-help-block">Invalid Code Entered</b-form-invalid-feedback>

   <b-button id="submit-id" type="submit" block variant="outline-primary" class="mt-3">Submit</b-button>
      </b-form>
    </b-col>
  </b-row>
</b-container>

</template>

<script>
  import { getAPI } from '../store/axios-base'
    export default {
        name: "Voucher.vue",
        data:()=>{
            return {
                voucher:'',
                valid: true,
            }
        },
        methods:{
            submitVoucher:function() {
                var headers = {Authorization: `Bearer ${this.$store.state.accessToken}`}
                var voucher_data = {vouchercode: this.voucher}
                getAPI.post("/api/account/voucher/", voucher_data, {headers: headers}).then(response => {
                    if (response.data.success == 'true') {
                        this.$parent.showAlert('voucher')
                        this.$router.push('profile')
                    } else {
                        this.valid = false;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Voucher.vue